import React, { useState, useEffect, useRef } from "react";
import * as MdIcons from "react-icons/md";
import * as FaIcons from "react-icons/fa";
import * as BsIcons from "react-icons/bs";
import * as TbIcons from "react-icons/tb";
import * as HiIcons from "react-icons/hi";
import * as IoIcons from "react-icons/io5";
import { Link } from "react-scroll";
import { useNavigate } from "react-router-dom";
import "../Styles.css";
import { useTheme } from "components/Hooks/darkmode";
import * as FiIcons from "react-icons/fi";
import AOS from "aos";
import "aos/dist/aos.css";

const img: string = require("../../assets/bg3.jpg");

const SideBar = () => {
  const [navBar, setNavBar] = useState(true);
  const [lapBar, setlapBar] = useState(false);
  const { theme, setTheme } = useTheme();
  function handleToggleTheme() {
    setTheme(!theme);
  }
  useEffect(() => {
    var lastScrollTop = 0;
    window.addEventListener(
      "scroll",
      () => {
        var st = window.pageYOffset || document.documentElement.scrollTop;

        if (st > lastScrollTop) {
          setNavBar(false);
        } else if (st < lastScrollTop) {
          setNavBar(true);
        }
        lastScrollTop = st <= 0 ? 0 : st;
      },
      false
    );
  }, []);

  const nav = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 300 });
  }, []);

  const token = JSON.parse(
    localStorage.getItem("userCredentials") || "{}"
  )?.accessToken;

  return (
    <>
      <div
        className={`flex fixed  ${
          navBar ? "scrolled" : "fixed_menu"
        } left-0 right-0 items-center shadow-md dark:shadow-slate-400 shadow-black bg-[#ffffff] dark:bg-[#002137] justify-evenly h-10`}
        id="cont"
      >
        <div onClick={() => nav(!token ? "admin-login" : "dashboard")}>
          {" "}
          <FaIcons.FaUserAlt className="text-[16px]" />
        </div>
        <div>
          <span
            className=" hover:text-[#009dff]  border-b-[#009dff] py-1 px-2  cursor-pointer "
            onClick={handleToggleTheme}
          >
            {!theme ? (
              <FiIcons.FiSun className="text-[16px]" />
            ) : (
              <BsIcons.BsFillMoonFill className="text-[16px]" />
            )}
          </span>
        </div>
        <div onClick={() => setlapBar(true)}>
          <TbIcons.TbGridDots className="text-[16px]" />
        </div>
      </div>
      <div
        className={` shadow-md dark:shadow-slate-400 shadow-black rounded-t-[20px] fixed h-[175px] left-0 right-0 bottom-[-175px]  dark:bg-[#002137] bg-white ${
          lapBar
            ? "bottom-0 new_scroll"
            : "bottom-[-250px] rounded-[10px] new_element"
        }`}
        id="box"
      >
        <ul className=" items-center   grid  grid-cols-3 grid-rows-3 gap-y-3 pt-3">
          <li className="nav-item">
            <Link
              to="section_1"
              spy={true}
              smooth={true}
              offset={-100}
              duration={1000}
              onClick={() => {
                setTimeout(() => {
                  setlapBar(false);
                }, 200);
              }}
            >
              <div className="flex flex-col items-center px-[0px] rounded-[50%] justify-items-end  hover:bg-[#6b7479] w-fit aspect-square mx-auto">
                <div className="w-fit aspect-square rounded-[50%]">
                  <FaIcons.FaHome />
                </div>
                <div>Home</div>
              </div>
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="section_3"
              spy={true}
              smooth={true}
              offset={0}
              duration={1000}
              onClick={() => {
                setTimeout(() => {
                  setlapBar(false);
                }, 200);
              }}
            >
              <div className="flex flex-col items-center px-[0px] rounded-[50%] justify-items-end  hover:bg-[#6b7479] w-fit aspect-square mx-auto">
                <div className="w-fit aspect-square rounded-[50%]">
                  <FaIcons.FaUser />
                </div>
                <div>About</div>
              </div>
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="section_5"
              spy={true}
              smooth={true}
              offset={0}
              duration={1000}
              onClick={() => {
                setTimeout(() => {
                  setlapBar(false);
                }, 200);
              }}
            >
              <div className="flex flex-col items-center px-[0px] rounded-[50%] justify-items-end  hover:bg-[#6b7479] w-fit aspect-square mx-auto">
                <div className="w-fit aspect-square rounded-[50%]">
                  <HiIcons.HiLightBulb />
                </div>
                <div>Skills</div>
              </div>
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="section_7"
              spy={true}
              smooth={true}
              offset={0}
              duration={1000}
              onClick={() => {
                setTimeout(() => {
                  setlapBar(false);
                }, 200);
              }}
            >
              <div className="flex flex-col items-center px-[0px] rounded-[50%] justify-items-end  hover:bg-[#6b7479] w-fit aspect-square mx-auto">
                <div className="w-fit aspect-square rounded-[50%]">
                  <BsIcons.BsGridFill />
                </div>
                <div>Projects</div>
              </div>
            </Link>
          </li>
          {/* <li className="nav-item">
            <Link
              to="section_9"
              spy={true}
              smooth={true}
              offset={0}
              duration={1000}
              onClick={() => {
                setTimeout(() => {
                  setlapBar(false);
                }, 200);
              }}
            >
              <div className="flex flex-col items-center px-[0px] rounded-[50%] justify-items-end  hover:bg-[#6b7479] w-fit aspect-square mb-4 mx-auto">
                <div className="w-fit aspect-square rounded-[50%]">
                  <FaIcons.FaBlog />
                </div>
                <div>Blog</div>
              </div>
            </Link>
          </li> */}
          <li className="nav-item">
            <Link
              to="section_11"
              spy={true}
              smooth={true}
              offset={0}
              duration={1000}
              onClick={() => {
                setTimeout(() => {
                  setlapBar(false);
                }, 200);
              }}
            >
              <div className="flex flex-col items-center px-[0px] rounded-[50%] justify-items-end  hover:bg-[#6b7479] w-fit aspect-square mx-auto">
                <div className="w-fit aspect-square rounded-[50%]">
                  <IoIcons.IoPaperPlane />
                </div>
                <div>Contact</div>
              </div>
            </Link>
          </li>
        </ul>
        <div
          onClick={() => setlapBar(false)}
          className="absolute bottom-5 right-5"
        >
          <MdIcons.MdClose className="text-[20px]" />
        </div>
      </div>
    </>
  );
};

export default SideBar;

// bg-[#9B59B6]
